import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { db, auth } from "../_shoru_shared_library/firebase/firebase_setup";
import {
  createUserWithEmailAndPassword
} from 'firebase/auth';
import {v4 as uuidv4} from 'uuid';


const validateInvite = async(organisation, inviteId, setInviteValid, setInviteData) => {

  const docRef = doc(db, organisation, 'project-data', 'active-invites', inviteId);

  try
  {
    const qDoc = await getDoc(docRef);
    const data = qDoc.data();
    console.log(data);
    if(data !== undefined) {
      setInviteValid(true);
      setInviteData(data);
    }
    else
    {
      alert('Invalid invite link');
      //window.location.replace('/');
    }
  }
  catch(err)
  {
    alert('An error occured trying to validate your invite link');
    console.error(err);
  }

}

const validateProjectID = async(organisation, projectId) => {
  const docRef = doc(db, organisation, 'project-data', 'projects', projectId);

  try
  {
    const qDoc = await getDoc(docRef);
    const data = qDoc.data();
    if(data === undefined) {
      return true;
    }
    else
    {
      alert('This project ID (' + projectId + ') is already taken. Please choose another.');
      return false;
    }
  }
  catch(err)
  {
    alert('An error occured trying to validate your project ID');
    console.error(err);
    return false;
  }
}

const checkIfUserExists = async(email, setUserData) => {
  try {
    const q = query(collection(db, 'users'), where('email', '==', email));
    const qDoc = await getDocs(q);
    const data = qDoc.docs[0].data();
    setUserData(data);
    return true;
  }
  catch (err) {
    return false;
  }
}

const createUserAndAcceptInvite = async(organisation, email, firstName, lastName, password, inviteData, setState, existingUserData) => {
  if(existingUserData === null) {
    // Create the new user in Firebase
    await createUserWithEmailAndPassword(auth, email, password).then(async(res) => {
      const user = res.user;

      // Create user documents
      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        active_organisation_id: organisation,
        email: email,
        name: firstName,
        last_name: lastName,
        organisation_memberships: [organisation],
        organisations: [
          {
            id: organisation,
            admin: false,
            active_project_id: null,
            joined: getTodaysDate(),
            projects: []
          }
        ]
      }).then(async() => {
        const mailRef = collection(db, 'mail');
        // Send confirmation email to project admin
        await addDoc(mailRef, {
          to: email,
          message: {
            subject: `Welcome to Shoru`,
            html: `Hi,<br/><br/>
                  Welcome to Shoru - thank you for joining us!<br/><br/>
                  You can access the console here: <a href="${window.location.origin}/console">${window.location.origin}/console</a><br/><br/>
                  <br/>
                  Many thanks,<br/>
                  Shoru<br/><br/>
                  <small>(This is an automated email. Responses will not be seen.)</small>`
          }
        }).then(async() => {
          const inviteRef = doc(db, organisation, 'project-data', 'active-invites', inviteData.uid);
          await deleteDoc(inviteRef).then(() => {
            setState(2);
          })
        }, (rejection) => {console.log(rejection); alert('An error occurred')})

      }, (rejection) => {console.log(rejection); alert('An error occurred')})

    }, (rejection) => {console.log(rejection); alert('An error occurred')})
  }
  else {
    // Check if user is already part of the organisation
    let newUserData = {...existingUserData};
    const inOrganisation = existingUserData.organisations.some((o) => o.id === organisation);
    if (!inOrganisation) {
      newUserData.organisation_memberships = [...newUserData.organisation_memberships, organisation];
      newUserData.organisations = [...newUserData.organisations, {
        active_project_id: null,
        admin: false,
        id: organisation,
        joined: getTodaysDate(),
        projects: []
      }]
    }
    newUserData.active_organisation_id = organisation;
    // Create user documents
    await setDoc(doc(db, 'users', existingUserData.uid), newUserData).then(async() => {
      const mailRef = collection(db, 'mail');
      // Send confirmation email to project admin
      await addDoc(mailRef, {
        to: email,
        message: {
          subject: `Organisation Invite Accepted`,
          html: `Hi,<br/><br/>
                You recently accepted an invite to join a new organisation (${organisation}). You can access the console here: <a href="${window.location.origin}/console">${window.location.origin}/console</a><br/><br/>
                <br/>
                Many thanks,<br/>
                Shoru<br/><br/>
                <small>(This is an automated email. Responses will not be seen.)</small>`
        }
      }).then(async() => {
        const inviteRef = doc(db, organisation, 'project-data', 'active-invites', inviteData.uid);
        await deleteDoc(inviteRef).then(() => {
          setState(2);
        })
      }, (rejection) => {console.log(rejection); alert('An error occurred')})

    }, (rejection) => {console.log(rejection); alert('An error occurred')})
  }
}

const createProject = async(organisation, email, firstName, lastName, password, projectName, projectId, playwright, inviteData, setState, existingUserData) => {

  // If we're to create a new user
  if(existingUserData === null) {
    // Create the new user in Firebase
    await createUserWithEmailAndPassword(auth, email, password).then(async(res) => {
      const user = res.user;

      // Create project-data documents
      const projectDataRef = doc(db, organisation, 'project-data', 'projects', projectId);
      await setDoc(projectDataRef, {
        email_recipients: [user.uid],
        name: projectName,
        playwright: playwright.trim(),
        season: inviteData.season,
        uid: projectId,
        project_type: inviteData.project_type,
        week: inviteData.week
      }).then(async() => {

        // Create castingbot documents
        const castingBotRef = doc(db, organisation, 'castingbot', 'projects', projectId);
        await setDoc(castingBotRef, {
          booking_enabled: false,
          roles: [],
          slots: [],
          times: [],
          uid: projectId
        }).then(async() => {
          // Create user documents
          await setDoc(doc(db, 'users', user.uid), {
            uid: user.uid,
            active_organisation_id: organisation,
            email: email,
            name: firstName,
            last_name: lastName,
            organisation_memberships: [organisation],
            organisations: [
              {
                id: organisation,
                admin: false,
                active_project_id: projectId,
                joined: getTodaysDate(),
                projects: [
                  {
                    admin: true,
                    id: projectId
                  }
                ]
              }
            ]
          }).then(async() => {
            const mailRef = collection(db, 'mail');
            // Send confirmation email to project admin
            await addDoc(mailRef, {
              to: email,
              message: {
                subject: `Welcome to Shoru`,
                html: `Hi,<br/><br/>
                      Welcome to Shoru - thank you for joining us!<br/><br/>
                      Your new project, ${projectName}, is ready to view in your CastingBot console. You can access the console here: <a href="${window.location.origin}/console">${window.location.origin}/console</a><br/><br/>
                      <br/>
                      Many thanks,<br/>
                      Shoru<br/><br/>
                      <small>(This is an automated email. Responses will not be seen.)</small>`
              }
            }).then(async() => {
              const inviteRef = doc(db, organisation, 'project-data', 'active-invites', inviteData.uid);
              await deleteDoc(inviteRef).then(() => {
                setState(3);
              })
            }, (rejection) => {console.log(rejection); alert('An error occurred')})

          }, (rejection) => {console.log(rejection); alert('An error occurred')})

        }, (rejection) => {console.log(rejection); alert('An error occurred')})

      }, (rejection) => {console.log(rejection); alert('An error occurred')})

    }, (rejection) => {console.log(rejection); alert('An error occurred')})
  }

  // If we aren't creating a new user
  else {
    // Create project-data documents
    const projectDataRef = doc(db, organisation, 'project-data', 'projects', projectId);
    await setDoc(projectDataRef, {
      email_recipients: [existingUserData.uid],
      name: projectName,
      playwright: playwright.trim(),
      season: inviteData.season,
      uid: projectId,
      project_type: inviteData.project_type,
      week: inviteData.week
    }).then(async() => {

      // Create castingbot documents
      const castingBotRef = doc(db, organisation, 'castingbot', 'projects', projectId);
      await setDoc(castingBotRef, {
        booking_enabled: false,
        roles: [],
        slots: [],
        times: [],
        uid: projectId
      }).then(async() => {

        var newUserData = existingUserData;
        newUserData.active_organisation_id = organisation;
        // Check if user is already part of the organisation
        var inOrganisation = false;
        existingUserData.organisations.forEach((o, index) => {
          if(o.id === organisation) {
            newUserData.organisations[index].projects = [...o.projects, {id: projectId, admin: true}]
            newUserData.organisations[index].active_project_id = projectId;
            inOrganisation = true;
          }
        })
        if (!inOrganisation) {
          newUserData.organisation_memberships = [...newUserData.organisation_memberships, organisation];
          newUserData.organisations = [...newUserData.organisations, {
            active_project_id: projectId,
            admin: false,
            id: organisation,
            joined: getTodaysDate(),
            projects: [
              {
                admin: true,
                id: projectId
              }
            ]
          }]
        }
        // Create user documents
        await setDoc(doc(db, 'users', existingUserData.uid), newUserData).then(async() => {
          const mailRef = collection(db, 'mail');
          // Send confirmation email to project admin
          await addDoc(mailRef, {
            to: email,
            message: {
              subject: `Your New Project is Ready to View`,
              html: `Hi,<br/><br/>
                    Your new project, ${projectName}, is ready to view in your CastingBot console. You can access the console here: <a href="${window.location.origin}/console">${window.location.origin}/console</a><br/><br/>
                    <br/>
                    Many thanks,<br/>
                    Shoru<br/><br/>
                    <small>(This is an automated email. Responses will not be seen.)</small>`
            }
          }).then(async() => {
            const inviteRef = doc(db, organisation, 'project-data', 'active-invites', inviteData.uid);
            await deleteDoc(inviteRef).then(() => {
              setState(3);
            })
          }, (rejection) => {console.log(rejection); alert('An error occurred')})

        }, (rejection) => {console.log(rejection); alert('An error occurred')})

      }, (rejection) => {console.log(rejection); alert('An error occurred')})

    }, (rejection) => {console.log(rejection); alert('An error occurred')})
  }

}

const createInviteLink = async(organisation, type, season, week) => {
  const uid = uuidv4();
  const inviteRef = doc(db, organisation, 'project-data', 'active-invites', uid);
  try {
    await setDoc(inviteRef, {
      project_id: null,
      project_type: type,
      season: season,
      week: parseInt(week),
      uid: uid
    })
    return uid;
  }
  catch(err) {
    alert('Failed!')
  }
}

const resetCastingBot = async(organisation) => {

  try
  {
    // Clear all user's information
    await getDocs(collection(db, organisation, "castingbot", "projects"))
    .then((docs) => {

      docs.forEach(async(docItem) => {

        const projectData = docItem.data();

        // Reset CastingBot documents to default
        await setDoc(doc(db, organisation, "castingbot", "projects", projectData.uid), {
          booking_enabled: false,
          slots: [],
          times: [],
          roles: [],
          uid: projectData.uid
        });

      })
    })
  
    // Clear all audiitonees
    await getDocs(collection(db, organisation, "castingbot", "auditionees"))
    .then((docs) => {

      docs.forEach(async(docItem) => {
        const auditionee = docItem.data();
        const docRef = doc(db, organisation, "castingbot", "auditionees", auditionee.uid);
        await deleteDoc(docRef);
      })

    })

    alert("CastingBot data successfully cleared.");

  }
  catch(err)
  {
    alert("Error occurred whilst resetting CastingBot");
    console.log(err);
  }

}

function getTodaysDate() {
  const today = new Date();

  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();

  return `${day}/${month}/${year}`;
}


export {
  validateInvite,
  validateProjectID,
  checkIfUserExists,
  createProject,
  createUserAndAcceptInvite,
  createInviteLink,
  resetCastingBot
}